module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "index",
    attrs: {
      "element-loading-text": _vm.$t('common.loading')
    }
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('home.crumbs.L1')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('h2', {
    staticClass: "panel-header__desc"
  }, [_vm._v(_vm._s(_vm.$t('home.title.t1')))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-today"
  }, [_c('div', {
    staticClass: "fee"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('home.panel.t2')))]), _vm._v(" "), _c('strong', [_c('em', [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.info.today_total_amt)))]), _vm._v(" " + _vm._s(_vm.role.currency))]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_c('i'), _vm._v(_vm._s(_vm.$t('home.panel.tta')))]), _vm._v(" "), _c('span', [_c('em', [_vm._v(_vm._s(_vm.info.nums || 0))]), _vm._v(_vm._s(_vm.role.haiwai ? '' : ' 笔'))])]), _vm._v(" "), _c('li', [_c('strong', [_c('i'), _vm._v(_vm._s(_vm.$t('home.panel.tincome')))]), _vm._v(" "), _c('span', [_c('em', [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.info.today_txamt)))]), _vm._v(" " + _vm._s(_vm.role.currency))])]), _vm._v(" "), _c('li', [_c('strong', [_c('i'), _vm._v(_vm._s(_vm.$t('home.panel.cmincome')))]), _vm._v(" "), _c('span', [_c('em', [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.info.month_txamt)))]), _vm._v(" " + _vm._s(_vm.role.currency))])])])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "panel down"
  }, [_c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('h2', {
    staticClass: "panel-header__desc"
  }, [_vm._v(_vm._s(_vm.$t('home.title.t2')))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-header__auto"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form
    }
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.panel.time')))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "dateRangeValue"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "editable": false,
      "placeholder": _vm.$t('tradeMng.panel.range'),
      "size": "small",
      "clearable": false
    },
    on: {
      "change": _vm.timeChange
    },
    model: {
      value: (_vm.form.dateRangeValue),
      callback: function($$v) {
        _vm.$set(_vm.form, "dateRangeValue", $$v)
      },
      expression: "form.dateRangeValue"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "choosetime"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('common.all'),
      "size": "small"
    },
    on: {
      "change": _vm.changeTime
    },
    model: {
      value: (_vm.form.choosetime),
      callback: function($$v) {
        _vm.$set(_vm.form, "choosetime", $$v)
      },
      expression: "form.choosetime"
    }
  }, _vm._l((_vm.choosetimes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group"
  }, [(!_vm.role.single) ? _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.panel.shopName')))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "selectShopUid"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('common.all'),
      "size": "small"
    },
    on: {
      "change": function($event) {
        return _vm.getOperators(_vm.form.selectShopUid)
      }
    },
    model: {
      value: (_vm.form.selectShopUid),
      callback: function($$v) {
        _vm.$set(_vm.form, "selectShopUid", $$v)
      },
      expression: "form.selectShopUid"
    }
  }, _vm._l((_vm.shopData.list), function(shop) {
    return _c('el-option', {
      key: shop.uid,
      attrs: {
        "label": shop.shop_name,
        "value": shop.uid
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.role.isCashier) ? _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.panel.operator')))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "operaValue"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('tradeMng.table.all'),
      "size": "small",
      "disabled": _vm.form.selectShopUid === ''
    },
    on: {
      "change": _vm.operaChange
    },
    model: {
      value: (_vm.form.operaValue),
      callback: function($$v) {
        _vm.$set(_vm.form, "operaValue", $$v)
      },
      expression: "form.operaValue"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('tradeMng.table.all'),
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('tradeMng.table.main'),
      "value": "vl"
    }
  }), _vm._v(" "), _vm._l((_vm.operaList), function(label, value) {
    return _c('el-option', {
      key: value,
      attrs: {
        "label": label,
        "value": value
      }
    })
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-header-btn-group"
  }, [_c('div', {
    staticClass: "panel-header-btn panel-header-btn__fill",
    on: {
      "click": _vm.search
    }
  }, [(_vm.loading1) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v(_vm._s(_vm.$t('tradeMng.panel.btn.query')))])])])])])], 1), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "main"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body panel-today"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "line"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-753ce40e"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/index/index.vue
// module id = 925
// module chunks = 0